import React from 'react'

function YogaPoster() {
    return (
        <div>
        <div className="page-desc">
          <div className="page-desc-content">
            <h3>Equipments</h3>
            <h1>Yoga</h1>
          </div>
        </div>
      </div>
    )
}

export default YogaPoster
